/**
 * @fileoverview Animals theme - match animal emojis.
 */

import { ThemeOptions } from '../../../services/ThemeService.js';
import { EmojiMatchingTheme } from '../../abstract/EmojiMatchingTheme.js';
import { allLabels } from '../../Labels.js';

export class OceanTheme extends EmojiMatchingTheme {
    constructor(options: ThemeOptions = {}) {
        super(
            'ocean',
            'Ocean Creatures',
            allLabels.ocean,
            { numPairs: 6, ...options }
        );
    }
}
